import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { ItistateapiService } from '../../../api/itistateapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";
import { element } from 'protractor';

@Component({
  selector: 'app-showpaytable',
  templateUrl: './showpaytable.component.html',
  styleUrls: ['./showpaytable.component.css']
})
export class ShowpaytableComponent implements OnInit {

  public bool_paynow:boolean  =true;
  public totCount:number = 0;
  public studcount:number = 0;
  public Iticount:any[] = [];
  public totCountArray:any = [];
  public seltable:any = [];

  public bool_table:boolean = true;
  public bool_offline_form:boolean = false;
  public bool_offln_submit:boolean = false;
  public nimiForm:any;
  submitted = false;

  @ViewChild('paginator_payMaster') paginator_payMaster!: MatPaginator;
  @ViewChild('sort_payMaster') sort_payMaster!: MatSort;

  displayedColumnspayMaster = ['selects', 'slno', 'payrefid', 'iticode', 'payrefdate','noofstu', 'amount', 'ccaveref', 'paymentdate','pstatus'];
  SRC_SELECTED_FAMILYMEMBER_payMaster: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER_payMaster = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_payMaster);
  dataSource_payMaster = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_payMaster);
  selected_family_member_payMaster = new SelectionModel<Element>(true, []);
  public int_index_edit_payMaster: any;
  totallength_paymaster:any = 1 ;
  
  public pduTable: any;
  public query: string = '';
  public page: number = 1;
  public offset: number = 5;
  public pageEvent: any;
  totallength:any = 1 ;

  reciveuserid:any;
  reciveMobilemo:any;
  reciveemail:any;
  reciveeITIStateCode:any;
  reciveeITIStateName:any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private itistateapi: ItistateapiService,  private router: Router, private httpClient: HttpClient) { }

  ngOnInit(): void {


    this.reciveuserid = window.localStorage.getItem('ITIStateLoginId');
      this.reciveemail = window.localStorage.getItem('ITIStateEmail');
      this.reciveMobilemo = window.localStorage.getItem('ITIStateMobile');
      this.reciveeITIStateCode = window.localStorage.getItem('ITIStateCode');
      this.reciveeITIStateName = window.localStorage.getItem('state');

      this.nimiForm = this.formBuilder.group({
        paymode: ['', Validators.required ],
        refno: ['', Validators.required ],
        state: ['', Validators.required ],
        iticode: ['', Validators.required],
        amount: ['', Validators.required ],
        date: ['', Validators.required ],                
      }); 

    let args = {
      loginid: this.reciveuserid
    };
    this.itistateapi.showStateItiMasterTable(args).subscribe((result: any) => {

      // this.itiHeaderName = result[0]['itiname'];
      // this.itiHeaderemail = result[0]['itiemail'];
      // this.itiHeaderMobile = result[0]['itimobile'];
      // this.itiHeaderCode = result[0]['iticode'];

      this.SRC_SELECTED_FAMILYMEMBER_payMaster = result;
      this.DATA_SELECTED_FAMILYMEMBER_payMaster = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_payMaster);
      this.dataSource_payMaster = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_payMaster);
      //this.ngAfterViewInit();
      this.dataSource_payMaster.paginator = this.paginator_payMaster;        
      this.dataSource_payMaster.sort = this.sort_payMaster;
    //  this.bool_itiForm = false;
      console.log(JSON.stringify(result));
      this.totallength_paymaster = result.length;
      console.log(JSON.stringify(result));
      // this.bool_table = false;
      // this.bool_Master_table = true;
      });

  }

  get f() {
    return this.nimiForm.controls;
  }

  payMasterView(){

  }

  payMaster(){
    this.selected_family_member_payMaster.selected.forEach((item:any) => {
      var msg = JSON.stringify(item);
      var msgOb = JSON.parse(msg)
      console.log("MSG: " + msg)
      const formData = new FormData();
      formData.append('data', msg);
    
      var myargs = formData;
      //var myargsText = this.uploadForm.value;
      console.log(msgOb.iticode);
  
   

      let a = {
        userid: msgOb.payrefid,
        amount: msgOb.amount,
        bname: msgOb.itiname,
        baddress: 'nimi',
        bcity: 'chennai',
        bdistrict: msgOb.districtname,
        bstate: msgOb.statename,
        bpincode: '600032',
        bmobile: msgOb.itimobile,
        bemail: msgOb.itiemail,
      };

     //window.location.href = 'https://www.nimionlineadmission.in/dgt/paynow.php'

     this.api.payMasterdata(a,"https://www.nimionlineadmission.in/dgt/paynow.php");

           this.selected_family_member_payMaster.clear() 
      // this.api.payMasterdata(myargs).subscribe((data: any) => {

      // });
      });
  }
  
  selectRow(event:any,element:any){
    //console.log(event.target.firstChild.children[1]);
    console.log(event);
    let count = element.noofstu;
   // this.studcount = element.count;
    let mulValue = count * 376;

    this.bool_paynow = false;

    if(event.checked){
      this.totCount += mulValue;
      this.studcount += count;
    }
    else{
      this.totCount -= mulValue;
      this.studcount -= count;
    }

    if(this.studcount==0){
      this.bool_paynow = true;
    }
    
  }

  offln_form_fn(){
    this.seltable = [];
    this.bool_paynow = false;
    this.selected_family_member_payMaster.selected.forEach((s)=>{   
      this.seltable.push(s);
      //alert(JSON.stringify(this.seltable))  
      // this.seltable.concat(JSON.stringify({name: 'nantha'}));
    });
 
    
    
    for(let i=0; i<this.seltable.length; i++){
      this.Iticount.push(this.seltable[i]['iticode']);
    }
    this.bool_table = false;
    this.bool_offline_form = true;

  }
  
  onnimiSubmit(){

    this.submitted = true;

    if (this.nimiForm.invalid) {
      alert('Fill the form');
      return;
    }
    this.bool_offln_submit = true;

    this.seltable.forEach((value:any, key:any) => {
      value['comanId']={commanloginid: this.reciveuserid, commanlemail: this.reciveemail, commanlmobile: this.reciveMobilemo, commanstudCount: this.studcount, offlineform: this.nimiForm.value  };
    });
    console.log(JSON.stringify(this.seltable));
    
    this.itistateapi.importStateOfflineTable(this.seltable).subscribe((result: any) => {
      this.seltable=[];
      let status = result.status;

      if(status == 'success'){
          this.router.navigateByUrl('/examfeestate/showpaytable')
        
      }
    });


  }

  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

}
